import React from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import ButtonIcon from '../../../../../../../features/components/Buttons/ButtonIcon'

import { ReactComponent as TrashIcon } from '../../../../../../../assets/icons/trash.svg'
import { ReactComponent as ExpandIcon } from '../../../../../../../assets/icons/expand.svg'
import { ReactComponent as MinimizeIcon } from '../../../../../../../assets/icons/minimize.svg'

import { ordinalSuffixOf } from '../../../../../../../features/helpers/adsHelpers'

import useStyles from './styles'
import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

const ItemForm = ({
  isOpened,
  deleteItem,
  closeForm,
  selectForm,
  index,
  isRemovable,
  children,
  isItemActive,
  isValid,
  mediaFileError,
  itemFormTitle = 'image or video'
}) => {
  const classes = useStyles({ isItemActive, isValid, mediaFileError })
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  return isOpened ? (
    <div className={classes.carouselItemForm}>
      <div className={classes.title}>
        {ordinalSuffixOf(index + 1)} {t(` ${itemFormTitle}`)}
      </div>
      <ButtonIcon
        className={classnames(drawerFormClasses.sectionIcon, classes.iconButton)}
        onClick={closeForm}
        Icon={MinimizeIcon}
      />
      {isRemovable && <ButtonIcon className={classes.removePostBtn} Icon={TrashIcon} onClick={deleteItem} />}
      {children}
    </div>
  ) : (
    <div className={classnames(classes.carouselItemForm, classes.carouselItemFormMinimized)} onClick={selectForm}>
      <div className={classes.title}>
        {ordinalSuffixOf(index + 1)} {t(` ${itemFormTitle}`)}
      </div>
      <ButtonIcon className={classnames(drawerFormClasses.sectionIcon, classes.iconButton)} Icon={ExpandIcon} />
    </div>
  )
}

ItemForm.propTypes = {}

export default ItemForm
